<template>
  <div class="btn-group">
    <div v-for="(option, key) in options" v-bind:key="key" class="form-check form-check-inline">
      <input
          type="radio"
          v-model="content"
          class="form-check-input"
          :id="'radio_' + uid + '_' + key"
          :value="option[valueField]"
          :disabled="disabled"
          @input="updateInput"
      />
      <label class="form-check-label" :for="'radio_' + uid + '_' + key">
        {{ option[textField] }}
      </label>
    </div>
  </div>
</template>

<script>
import { v4 as uuidv4 } from 'uuid';
  export default {
    name: 'RadioField',
    props: {
      modelValue: {
        default: null
      },
      disabled: {
        default: false,
        type: Boolean
      },
      valueField: {
        default: 'value',
        type: String
      },
      textField: {
        default: 'text',
        type: String
      },
      options: {
        default: []
      }
    },

    data () {
      return {
        content: this.modelValue,
        uid: uuidv4()
      }
    },

    methods: {
      updateInput (e) {
        this.content = e.target.value;
        this.$emit('update:modelValue', this.content);
      }
    },

    watch: {
      modelValue () {
        if (this.content !== this.modelValue) {
          this.content = this.modelValue;
        }
      }
    }
  }
</script>